<div class="content-wrapper faq">

  <div class="right-side margin-auto">

    <div class="container business-section">

      <div id="faq" class="faq">


        <!-- Lista FAQ -->
        <ul>

          <li *ngFor="let data of faqList; let i = index">

            <div 
              class="accordion"
              [ngClass]="{'active': showThis === i && show === true}">


              <!-- Pregunta -->
              <div 
                class="faqHeader"
                (click)="toggleFaq(i)">

                {{langugaeCheck(data)}}

              </div>


              <!-- Respuesta -->
              <div 
                class="card"
                *ngIf="showThis === i && show === true">

                {{langugaeCheck2(data)}}

              </div>


            </div>

          </li>


        </ul>

      <div class="empty-faq" 
     *ngIf="!faqList || faqList.length === 0">

      No hay preguntas frecuentes disponibles.

    </div>


      </div>

    </div>

  </div>

</div>